import React from 'react';
import './Footer.css';
import appStore from '../../Assets/appstore.png';
import googlePlay from '../../Assets/googleplay.png';
import { SendOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Logo from '../Logo/Logo';
import { FacebookOutlined, InstagramOutlined, YoutubeOutlined, TikTokOutlined, WhatsAppOutlined } from '@ant-design/icons';

function Footer() {
  const categories = [
    {
      title: "O/A Level Secondary",
      items: [
        "O Level Classes",
        "A Level Classes",
        "Exam Paper Reviews",
        "Past Papers",
        "Subject Guides"
      ],
      linkItemsToCourses: true
    },
    {
      title: "Primary School Level",
      items: [
        "Standard 1-4 Classes",
        "Standard 5-7 Classes",
        "Study Materials",
        "PSLE Preparation",
        "Primary Syllabus"
      ],
      linkItemsToCourses: true
    },
    {
      title: "Kindergarten",
      items: [
        "Early Learning",
        "Interactive Classes",
        "ABCs & 123s",
        "Story Time",
        "Creative Activities"
      ],
      linkItemsToCourses: true
    },
    {
      title: "Colleges/Universities",
      items: [
        "Degree Programs",
        "Diploma Courses",
        "University Prep",
        "Research Materials",
        "Academic Writing"
      ],
      linkItemsToCourses: true
    },
    {
      title: "Company",
      items: [
        "About Us",
        "Our Classes",
      ],
      linkItemsToCourses: false
    },
    {
      title: "More",
      items: [
        "Terms of Service",
        "Privacy Policy",
        "Help Center",
        "Become a Teacher",
      ],
      linkItemsToCourses: false
    }
  ];

  return (
    <div className='footer-container'>
      <div className='footer-separater'>
        <div className='logo-roll'>
          <Logo />
          <p className='footer-about-paragraphy'>
           BeyondSchools is Tanzania's premier digital education platform revolutionizing learning 
           through innovative technology and personalized instruction. We're bridging the gap 
           between traditional education and 21st century digital learning needs.

           To democratize quality education by making comprehensive learning resources 
           to every Tanzanian student, regardless of location or economic background.
     
          </p>
          
          <span className='subscribe-text'>Subscribe to our Newsletter</span>
          <div className='newsletter'>
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="newsletter-input" 
              aria-label="Email for Newsletter"
            />
            <button className='send-button-newsletter'>
              <SendOutlined />
            </button>
          </div>
        </div>
        
        <div className='categories-grid'>
          {categories.map((category, index) => (
            <div key={index} className='category-column'>
              <span className='category-title'>{category.title}</span>
              <div className='category-items'>
                {category.items.map((item, itemIndex) => (
                  <Link 
                    to={category.linkItemsToCourses ? "/courses" : `/${item.toLowerCase().replace(/\s+/g, '-')}`} 
                    className='category-item' 
                    key={itemIndex}
                  >
                    {item}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className='footer-bottom'>
        <div className='mobile-download'>
          <span className='download-title'>Download Our App</span>
          <div className='download-buttons'>
            <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
              <img src={appStore} alt="App Store" className="app-download-size" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.oxenspace.BeyondschoolsApp" target="_blank" rel="noopener noreferrer">
              <img src={googlePlay} alt="Google Play" className="app-download-size" />
            </a>
          </div>
        </div>
        
        <div className='copyright'>
          © 2025 BeyondSchools. All rights reserved.
        </div>
        <div className='social-media'>
          <a href="https://www.facebook.com/share/1RF6JAJSSs/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
            <FacebookOutlined className='social-icon' />
          </a>
          <a href="http://www.tiktok.com/@beyondschools_tz" target="_blank" rel="noopener noreferrer">
            <TikTokOutlined  className='social-icon' />
          </a>
          <a href="https://www.instagram.com/beyondschools_tz?igsh=b2NubGs5bHljeW5o&utm_source=qr" target="_blank" rel="noopener noreferrer">
            <InstagramOutlined className='social-icon' />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
            <YoutubeOutlined className='social-icon' />
          </a>
          <a href="https://wa.me/255738867270" target="_blank" rel="noopener noreferrer">
            <WhatsAppOutlined className='social-icon' />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;